import { render, staticRenderFns } from "./product.vue?vue&type=template&id=1799d63a&scoped=true"
import script from "./product.vue?vue&type=script&lang=ts"
export * from "./product.vue?vue&type=script&lang=ts"
import style0 from "./product.vue?vue&type=style&index=0&id=1799d63a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799d63a",
  null
  
)

export default component.exports